import { CloseIcon } from 'components/icons/CloseIcon';
import { ModalContext } from 'context/ModalContext';
import { useContext } from 'react';

interface IChapterSummary {
  topics: any;
  chapterTitle: string;
}

export default function ChapterSummary({ topics, chapterTitle }: IChapterSummary) {
  const { hideModal } = useContext(ModalContext);

  const safeTopics = Array.isArray(topics) ? topics : [];

  return (
    <div className="transparent font-lato">
      <div className="relative border bg-gray-bg-dark border-gray-300 rounded-lg bg-white pb-7 pt-9 w-screen md:w-[622px] md:min-h-[200px]">
        <div className="flex px-7">
          <span className="font-bold text-2xl leading-6 text-[#1A1C1D]">Topics</span>
          <CloseIcon
            className="ml-auto w-5 h-5 cursor-pointer opacity-70 hover:opacity-100"
            onClick={() => hideModal()}
          />
        </div>
        <div
          className="mt-5 px-7 chapter-summary"
          style={{
            maxHeight: '60vh',
            overflowY: 'auto'
          }}
        >
          <ul className="list-disc pl-4">
            {safeTopics?.map((item: any, index: number) => (
              <li key={index} className="text-sm font-normal text-black pt-2">
                <p className="leading-[1.4]">{item.topic}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
